// extracted by mini-css-extract-plugin
var _1 = "ProjectActionsPopup_icon__c1BSG";
export { _1 as "icon" }
